var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-sidebar",
        {
          attrs: {
            title: _vm.atendimentoLocal.id
              ? _vm.atendimentoLocal.id + " - " + _vm.atendimentoLocal.titulo
              : "Novo Atendimento",
            right: "",
            shadow: "",
            backdrop: "",
            "backdrop-variant": "dark",
            width: "650px"
          },
          scopedSlots: _vm._u(
            [
              _vm.canSendMensage
                ? {
                    key: "footer",
                    fn: function() {
                      return [
                        _c(
                          "b-card",
                          { staticClass: "ml-1 mr-2 mb-1" },
                          [
                            _c(
                              "b-overlay",
                              { attrs: { show: _vm.loading, rounded: "sm" } },
                              [
                                !_vm.atendimentoLocal ||
                                !_vm.atendimentoLocal.id
                                  ? _c(
                                      "b-row",
                                      { staticClass: "mb-2" },
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-form-group",
                                              { attrs: { label: "Tipo" } },
                                              [
                                                _c("b-form-select", {
                                                  attrs: {
                                                    options: _vm.tipos,
                                                    placeholder:
                                                      "Informe o tipo de atendimento"
                                                  },
                                                  model: {
                                                    value: _vm.titulo,
                                                    callback: function($$v) {
                                                      _vm.titulo = $$v
                                                    },
                                                    expression: "titulo"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _vm.showAfterStartService
                                      ? _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: { label: _vm.labelChat }
                                              },
                                              [
                                                _c("b-form-textarea", {
                                                  attrs: {
                                                    disabled: _vm.loading,
                                                    placeholder:
                                                      "Digite uma mensagem ...",
                                                    rows: "2",
                                                    "max-rows": "8"
                                                  },
                                                  on: {
                                                    keyup: function($event) {
                                                      if (
                                                        !$event.type.indexOf(
                                                          "key"
                                                        ) &&
                                                        _vm._k(
                                                          $event.keyCode,
                                                          "enter",
                                                          13,
                                                          $event.key,
                                                          "Enter"
                                                        )
                                                      ) {
                                                        return null
                                                      }
                                                      return _vm.enviarMensagem()
                                                    },
                                                    input: function($event) {
                                                      return _vm.sendTyping()
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.mensagem,
                                                    callback: function($$v) {
                                                      _vm.mensagem = $$v
                                                    },
                                                    expression: "mensagem"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _vm.atendimentoLocal &&
                                _vm.atendimentoLocal.id &&
                                ((!_vm.isDistribuidor &&
                                  _vm.atendimentoLocal.status !== "NOVO" &&
                                  _vm.atendimentoLocal.user_id_atendente ==
                                    _vm.user.id) ||
                                  _vm.isDistribuidor)
                                  ? _c(
                                      "b-col",
                                      [
                                        !_vm.file
                                          ? _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  variant: "secondary",
                                                  size: "sm",
                                                  disabled: _vm.loading,
                                                  title: "Anexo"
                                                },
                                                on: {
                                                  click: _vm.triggerFileInput
                                                }
                                              },
                                              [
                                                _c("b-icon", {
                                                  attrs: { icon: "paperclip" }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("b-form-file", {
                                          ref: "fileInput",
                                          staticClass: "d-none",
                                          on: { input: _vm.handleFile },
                                          model: {
                                            value: _vm.file,
                                            callback: function($$v) {
                                              _vm.file = $$v
                                            },
                                            expression: "file"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm.file
                                          ? _c("p", [
                                              _vm._v(
                                                " Anexo: " +
                                                  _vm._s(_vm.file.name) +
                                                  "\n                            "
                                              ),
                                              !_vm.loading
                                                ? _c(
                                                    "a",
                                                    {
                                                      attrs: { href: "#" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.removeFile()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-times"
                                                      })
                                                    ]
                                                  )
                                                : _vm._e()
                                            ])
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "text-right" },
                                  [
                                    _vm.canFinishService
                                      ? _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              size: "sm",
                                              variant: "danger"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.encerrarAtendimento()
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-lock"
                                            }),
                                            _vm._v(
                                              " Encerrar Atendimento\n                        "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.canStartService
                                      ? _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              size: "sm",
                                              variant: "warning"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.iniciarAtendimento()
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-play-circle"
                                            }),
                                            _vm._v(
                                              " Iniciar Atendimento\n                        "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              size: "sm",
                                              variant: "success",
                                              disabled:
                                                _vm.loading ||
                                                (_vm.mensagem.length < 1 &&
                                                  !_vm.file)
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.enviarMensagem()
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-paper-plane"
                                            }),
                                            _vm._v(
                                              " Enviar\n                        "
                                            )
                                          ]
                                        )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                : null
            ],
            null,
            true
          ),
          model: {
            value: _vm.localSidebar,
            callback: function($$v) {
              _vm.localSidebar = $$v
            },
            expression: "localSidebar"
          }
        },
        [
          _c(
            "b-row",
            [
              !_vm.isDistribuidor && _vm.atendimentoLocal.distribuidor
                ? _c("b-col", { attrs: { cols: "8" } }, [
                    _c("h6", [
                      _vm._v(
                        _vm._s(_vm.atendimentoLocal.distribuidor.codigo) +
                          " - " +
                          _vm._s(_vm.atendimentoLocal.distribuidor.nome)
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("b-col", { staticClass: "text-right" }, [
                _c(
                  "h5",
                  [
                    _c("b-badge", [_vm._v(_vm._s(_vm.atendimentoLocal.status))])
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.atendimentoLocal &&
          _vm.atendimentoLocal.mensagens &&
          _vm.atendimentoLocal.mensagens.length > 0
            ? _c(
                "b-card",
                {
                  staticClass: "ml-1 mr-2 card-msgs",
                  attrs: { id: "card-msg" }
                },
                [
                  _c(
                    "div",
                    { ref: "chatcontainer", staticClass: "mb-3" },
                    _vm._l(_vm.atendimentoLocal.mensagens, function(
                      mensagem,
                      index
                    ) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          _c("v-atendimento-mensagens", {
                            attrs: { mensagem: mensagem }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d577a36", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d577a36","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/atendimento/Sidebar.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1d577a36","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/atendimento/Sidebar.vue
// module chunks = 2